/* Bunico sepet davranış eklemeleri (A7 · Görev 7.2 çekmece, 7.5 sepet sayfası). Yüklenir: bn_sepet_tasarim açık, sepet eylemi "overlay"
   ve sayfa /cart değilken (çekmece) YA DA /cart'ta bn_sepet_sayfa açıkken (sayfa) (layout/theme.liquid). Temanın JS dosyalarına dokunmaz (component-cart.js, section-header.js aynen):
   olay dinler, temanın açık yöntemini (sidebar-drawer.hide()) çağırır; tema iç fonksiyonlarını sarmalamaz.
   1) [data-bn-cart-close] ("Alışverişe devam et") çekmeceyi temanın yoluyla kapatır (tema yalnız ilk [data-js-close]'u bağlar).
   2) Açılışta odak çekmeceye girer; açıkken Tab çekmecede döner; kapanınca (Esc, ×, kaplama, "Alışverişe devam et") odak açan öğeye döner.
   3) AJAX yenilemesinden (cart-updated) sonra odak: aynı satırın aynı düğmesi; satır kalktıysa sonraki satırın adet alanı;
      sepet boşaldıysa başlık (#bn-cart-title, tabindex="-1").
   4) "Bununla iyi gider" (Görev 7.4) Ekle'sinden sonra odak eklenen ürünün sepet satırına (adı) alınır; yenilemede form DOM'dan
      çıktığı için odak gövdeye düşer. Tema eklemeden sonra document'a krown:cart:add gönderir; bu olay dinlenir.
   Sepet sayfasında (7.5) yalnız 3) (son satır kalkınca odak h1'e) ve 5): temanın cart-discounts hata metni Bunico metniyle verilir
   (KROWN.settings.locales.cart_discount_code_error, yalnız bu sayfada, "Uygula"ya basılırken); alana yazılınca hata temizlenir; kod
   eklenip/kaldırılıp #AjaxCartSubtotal yeniden çizilince odak gövdeye düştüyse indirim kodu alanına alınır.
   0) İki görünümde: istek sürerken (form#cart.processing) #AjaxCartSubtotal'daki bağlantı/düğmeler ve sepet formu gönderimi durdurulur (D33-N1). */
(() => {
  const form = document.getElementById('AjaxCartForm');
  if (!form) return;
  const sayfa = form.classList.contains('bn-cart__form--sayfa');
  const cekmece = sayfa ? null : document.getElementById('site-cart-sidebar');
  if (!sayfa && (!cekmece || !cekmece.classList.contains('bn-cart-drawer'))) return;
  const baslik = sayfa ? document.getElementById('bn-cart-page-title') : document.getElementById('bn-cart-title');
  const gorunur = e => !!e && e.getClientRects().length > 0 && getComputedStyle(e).visibility !== 'hidden';

  // ---- 0) İstek sürerken kilit (D33-N1) ----------------------------------------------------------------------------------------
  // Tema adet/indirim isteği sürerken form#cart'a "processing" ekler; CSS alt bölümü yalnız fareye kapatır. Klavye (Enter/Boşluk da
  // click üretir) ve form gönderimi burada durdurulur: güncel olmayan toplamla ödemeye geçilmez, /cart'a gidilmez.
  const islemde = () => !!document.querySelector('form#cart.processing');
  document.addEventListener('click', e => {
    if (!islemde() || !e.target.closest || !e.target.closest('#AjaxCartSubtotal')) return;
    if (!e.target.closest('a[href], button, input[type="submit"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
  document.addEventListener('submit', e => {
    if (e.target && e.target.id === 'cart' && islemde()) e.preventDefault();
  }, true);

  if (!sayfa) {
  // ---- 1) "Alışverişe devam et" ------------------------------------------------------------------------------------------------
  cekmece.addEventListener('click', e => {
    const dugme = e.target.closest('[data-bn-cart-close]');
    if (!dugme) return;
    e.preventDefault();
    const kap = dugme.closest('sidebar-drawer');
    if (kap && typeof kap.hide === 'function') kap.hide();
  });

  // ---- 2) Açan öğe, odak tuzağı, odağın geri dönmesi ----------------------------------------------------------------------------
  let sonDisOdak = null;
  let acan = null;
  document.addEventListener('focusin', e => { if (!cekmece.contains(e.target)) sonDisOdak = e.target; });

  const odaklanabilir = () => [...cekmece.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')]
    .filter(e => gorunur(e) && !e.closest('[inert], [aria-hidden="true"]'));

  let acik = cekmece.classList.contains('sidebar--opened');
  new MutationObserver(() => {
    const simdi = cekmece.classList.contains('sidebar--opened');
    if (simdi === acik) return;
    acik = simdi;
    if (simdi) {
      const tutamac = [...document.querySelectorAll('[aria-controls="site-cart-sidebar"][aria-expanded="true"]')].find(gorunur);
      acan = tutamac || (sonDisOdak && sonDisOdak !== document.body ? sonDisOdak : null);
      // Fareyle açılışta odak dışarıda kalır; dialog olduğu için başlığa alınır (klavyeyle açılışta tema × düğmesine odaklar).
      if (!cekmece.contains(document.activeElement) && baslik) baslik.focus({ preventScroll: true });
    } else {
      const geri = acan;
      acan = null;
      if (!geri || !geri.isConnected) return;
      // Tema Esc / Enter ile × yolunda odağı kendisi döndürebilir; odak hâlâ çekmecede ya da gövdedeyse burada döndürülür.
      setTimeout(() => {
        const a = document.activeElement;
        if (!a || a === document.body || cekmece.contains(a)) geri.focus({ preventScroll: true });
      }, 120);
    }
  }).observe(cekmece, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener('keydown', e => {
    if (e.key !== 'Tab' || !cekmece.classList.contains('sidebar--opened')) return;
    const liste = odaklanabilir();
    if (!liste.length) return;
    const ilk = liste[0], son = liste[liste.length - 1], a = document.activeElement;
    if (!cekmece.contains(a)) { e.preventDefault(); (e.shiftKey ? son : ilk).focus(); return; }
    if (e.shiftKey && (a === ilk || a === cekmece || a === baslik)) { e.preventDefault(); son.focus(); }
    else if (!e.shiftKey && a === son) { e.preventDefault(); ilk.focus(); }
  });

  }

  // ---- 3) Yenilemeden sonra odak ------------------------------------------------------------------------------------------------
  const TURLER = ['qty-plus', 'qty-minus', 'remove', 'qty'];
  let sonIslem = null;
  const kaydet = e => {
    const hedef = e.target.closest && e.target.closest('.qty-plus, .qty-minus, .remove, input.qty');
    const satir = hedef && hedef.closest('[data-js-cart-item]');
    if (!satir) return;
    sonIslem = { key: satir.dataset.id, line: Number(satir.dataset.line), tur: TURLER.find(t => hedef.classList.contains(t)),
      satirSayisi: form.querySelectorAll('[data-js-cart-item]').length };
  };
  form.addEventListener('click', kaydet, true);
  form.addEventListener('input', kaydet, true);

  form.addEventListener('cart-updated', () => {
    const k = sonIslem;
    sonIslem = null;
    if (!k || (!sayfa && !cekmece.classList.contains('sidebar--opened'))) return;
    const a = document.activeElement;
    // Kullanıcı bu arada başka bir öğeye geçtiyse odağa dokunulmaz (yenilemede eski düğme DOM'dan çıktığı için odak gövdeye düşer).
    if (a && a !== document.body && (sayfa || a !== cekmece) && a.isConnected) return;
    const satirlar = [...form.querySelectorAll('[data-js-cart-item]')];
    // Satır anahtarı indirim durumu değişince yenilenebilir: anahtar bulunamazsa satır sayısı aynıysa aynı sıradaki satır.
    const ayni = satirlar.find(s => s.dataset.id === k.key) || (satirlar.length === k.satirSayisi ? satirlar.find(s => Number(s.dataset.line) === k.line) : null);
    let hedef = null;
    if (ayni) hedef = ayni.querySelector('.' + k.tur) || ayni.querySelector('input.qty');
    else if (satirlar.length) {
      const sonraki = satirlar.find(s => Number(s.dataset.line) >= k.line) || satirlar[satirlar.length - 1];
      // İsimli tasma parçalarında adet girdisi yok (A11): sıradaki kaldır bağlantısı veya ürün adı.
      hedef = sonraki.querySelector('input.qty') || sonraki.querySelector('.remove') || sonraki.querySelector('.bn-cart__name');
    } else hedef = baslik;
    if (hedef) hedef.focus();
  });

  if (!sayfa) {
  // ---- 4) Öneriden eklemeden sonra odak ----------------------------------------------------------------------------------------
  let oneriEklenen = null;
  form.addEventListener('submit', e => {
    const s = e.target.closest && e.target.closest('#cart-recommendations [data-js-product-item]');
    oneriEklenen = s ? s.dataset.productId : null;
  }, true);
  document.addEventListener('krown:cart:add', () => {
    const id = oneriEklenen;
    oneriEklenen = null;
    if (!id || !cekmece.classList.contains('sidebar--opened')) return;
    const a = document.activeElement;
    if (a && a !== document.body && a !== cekmece && a.isConnected) return;
    const satir = form.querySelector(`[data-js-cart-item][data-product-id="${id}"]`);
    const hedef = (satir && satir.querySelector('.bn-cart__name')) || baslik;
    if (hedef) hedef.focus();
  });
  }

  // ---- 5) Sepet sayfası: indirim kodu hata metni ve odak --------------------------------------------------------------------------
  if (sayfa) {
    const alt = document.getElementById('AjaxCartSubtotal');
    if (!alt) return;
    let kodIslemi = false;
    alt.addEventListener('click', e => {
      const d = e.target.closest && e.target.closest('[data-js-discount-submit], [data-js-discount]');
      if (!d) return;
      const kutu = d.closest('cart-discounts');
      // Boş alanla "Uygula": tema istek atmaz, yenileme olmaz → bayrak açılmaz (sonraki ilgisiz yenilemede odak kaymasın).
      const girdi = kutu && kutu.querySelector('[data-js-discount-input]');
      kodIslemi = !(d.matches('[data-js-discount-submit]') && girdi && !girdi.value.length);
      const metin = kutu && kutu.dataset.bnHata;
      if (metin && window.KROWN && KROWN.settings && KROWN.settings.locales) {
        const span = document.createElement('span');
        span.className = 'alert alert--error text-size--small';
        span.textContent = metin;
        KROWN.settings.locales.cart_discount_code_error = span.outerHTML;
      }
    }, true);
    alt.addEventListener('input', e => {
      if (!e.target.matches || !e.target.matches('[data-js-discount-input]')) return;
      const kutu = e.target.closest('cart-discounts'), hata = kutu && kutu.querySelector('[data-js-discount-error]');
      if (hata && hata.innerHTML) hata.innerHTML = '';
    });
    new MutationObserver(() => {
      if (!kodIslemi) return;
      kodIslemi = false;
      const a = document.activeElement;
      if (a && a !== document.body && a.isConnected) return;
      const g = alt.querySelector('[data-js-discount-input]');
      if (g) g.focus({ preventScroll: true });
    }).observe(alt, { childList: true });
  }
})();
